module.exports = __webpack_public_path__ + "media/images/athletes/1306-1d3ef73addb04ed716ea3619adad9118.png";